// import React from "react";

// const InventoryTable = ({
//   title,
//   items = [],
//   selectedIds = [],
//   selectedQuantities = {},
//   isLoading = false,
//   onSelectAll,
//   onSelectOne,
//   onQuantityChange,
//   onScroll,
// }) => {
//   return (
//     <>
//       <h6 className="fw-bold">{title}</h6>
//       <div
//         className="mt-2 border p-3 rounded"
//         style={{ height: "400px", overflowY: "auto", borderRadius: "6px" }}
//         onScroll={onScroll}
//       >
//         <table className="table mb-0 text-center align-middle">
//           <thead>
//             <tr>
//               <th
//                 style={{
//                   backgroundColor: "#82c14a",
//                   color: "white",
//                   borderRadius: "6px 0 0 0",
//                 }}
//               >
//                 <input
//                   type="checkbox"
//                   onChange={onSelectAll}
//                   checked={
//                     items.length > 0 && selectedIds.length === items.length
//                   }
//                 />
//               </th>
//               <th style={{ backgroundColor: "#82c14a", color: "white" }}>
//                 SKU
//               </th>
//               <th style={{ backgroundColor: "#82c14a", color: "white" }}>
//                 Item Name
//               </th>
//               <th
//                 style={{
//                   backgroundColor: "#82c14a",
//                   color: "white",
//                   borderRadius: "0 6px 0 0",
//                 }}
//               >
//                 Quantity
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.map((item, idx) => (
//               <tr key={item.id || idx}>
//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={selectedIds.includes(item.id)}
//                     onChange={(e) => onSelectOne(e, item.id)}
//                   />
//                 </td>
//                 <td>{item.sku}</td>
//                 <td>{item.itemName}</td>
//                 <td>
//                   <input
//                     type="number"
//                     min="1"
//                     value={selectedQuantities[item.id]?.quantity || ""}
//                     onChange={(e) => onQuantityChange(e, item)}
//                     className="form-control form-control-sm text-center border-success"
//                     style={{ width: "60px", margin: "0 auto" }}
//                   />
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {isLoading && (
//           <div className="text-center my-3">
//             <div className="spinner-border text-success" role="status" />
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export const QuantityBulkInput = ({
//   quantity = "",
//   isDisabled = false,
//   onChange,
//   onUpdate,
// }) => {
//   return (
//     <div className="d-flex align-items-center gap-2 mb-3">
//       <input
//         type="number"
//         className="form-control form-control-md w-100"
//         placeholder="Quantity"
//         value={quantity}
//         onChange={onChange}
//         disabled={isDisabled}
//         style={{ width: "200px" }}
//       />
//       <button
//         className="btn"
//         style={{ backgroundColor: "#82c14a", color: "white" }}
//         disabled={isDisabled || quantity.trim() === ""}
//         onClick={onUpdate}
//       >
//         Update
//       </button>
//     </div>
//   );
// };

// export default InventoryTable;

import React from "react";
import Select from "react-select";

export const QuantityBulkInput = ({
  quantity = "",
  isDisabled = false,
  onChange,
  onUpdate,
}) => {
  const formatNumberWithCommas = (value) => {
    if (!value) return "";

    const parts = String(value).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };
  return (
    <div className="d-flex align-items-center gap-2 mb-3">
      {/* <input
        type="number"
        className="form-control form-control-md w-100"
        placeholder="Quantity"
        value={quantity}
        onChange={onChange}
        disabled={isDisabled}
        style={{ width: "200px" }}
      /> */}
      <input
        type="text" // changed from "number" to allow commas
        className="form-control form-control-md w-100"
        placeholder="Quantity"
        value={quantity ? formatNumberWithCommas(quantity) : ""}
        onChange={(e) => {
          let input = e.target.value;

          // Remove all commas
          let rawValue = input.replace(/,/g, "");

          // Allow only numbers and one decimal point
          if (rawValue && !/^\d*\.?\d*$/.test(rawValue)) {
            return;
          }

          // Create synthetic event with raw value (no commas)
          const syntheticEvent = {
            ...e,
            target: {
              ...e.target,
              value: rawValue,
            },
          };

          onChange(syntheticEvent);
        }}
        disabled={isDisabled}
        style={{ width: "200px" }}
      />
      <button
        className="btn"
        style={{ backgroundColor: "#82c14a", color: "white" }}
        disabled={isDisabled || quantity.trim() === ""}
        onClick={onUpdate}
      >
        Update
      </button>
    </div>
  );
};

const InventoryTable = ({
  title,
  items = [],
  selectedIds = [],
  selectedQuantities = {},
  isLoading = false,
  onSelectAll,
  onSelectOne,
  onQuantityChange,
  onScroll,
  searchKeyword = "",
  onSearchChange,
  showCheck,
  onChange,
  categories,
  selectedCategory,
}) => {
  const filteredItems = items.filter((item) =>
    item.itemName?.toLowerCase().includes(searchKeyword.toLowerCase()),
  );

  console.log("ddd", filteredItems);

  console.log("Items", items);

  const formatNumberWithCommas = (value) => {
    if (!value) return "";

    const parts = String(value).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  return (
    <div>
      <h6 className="fw-bold">{title}</h6>
      <div className="row mt-3 g-3 align-items-end mb-3">
        <div className="col-lg-7 col-12">
          <input
            type="text"
            className="form-control"
            placeholder="Search item name..."
            value={searchKeyword}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        <div className="col-lg-4 col-12">
          {/* <label className="form-label mb-2">Filter by Category</label> */}
          <Select
            value={selectedCategory}
            onChange={onChange}
            options={categories}
            isClearable
            placeholder="Select category..."
            className="react-select-container"
            classNamePrefix="react-select"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "42px",
              }),
            }}
          />
        </div>
      </div>
      <div
        className="border p-3 rounded"
        style={{ height: "400px", overflowY: "auto", borderRadius: "6px" }}
        onScroll={onScroll}
      >
        <table className="table mb-0 text-center align-middle">
          <thead>
            <tr>
              {showCheck && (
                <th
                  style={{
                    backgroundColor: "#82c14a",
                    color: "white",
                    borderRadius: "6px 0 0 0",
                  }}
                >
                  <input
                    type="checkbox"
                    onChange={onSelectAll}
                    checked={
                      filteredItems.length > 0 &&
                      selectedIds.length === filteredItems.length
                    }
                  />
                </th>
              )}
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                SKU
              </th>
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                Item Name
              </th>
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                Category
              </th>
              <th style={{ backgroundColor: "#82c14a", color: "white" }}>
                UOM
              </th>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                  borderRadius: "0 6px 0 0",
                }}
              >
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.length > 0 ? (
              filteredItems.map((item, idx) => (
                <tr key={item.id || idx}>
                  {showCheck && (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(item.id)}
                        onChange={(e) => onSelectOne(e, item.id)}
                      />
                    </td>
                  )}
                  <td>{item.sku}</td>
                  <td>{item.itemName}</td>
                  <td>{item?.category?.name}</td>
                  <td>{item.uom?.name}</td>
                  {/* <td>
                    <input
                      type="number"
                      min="0"
                      step="any" // allow 1.5, 0.25, etc.
                      inputMode="decimal" // better mobile keyboard
                      value={selectedQuantities[item.id]?.quantity || ""}
                      onChange={(e) => onQuantityChange(e, item)}
                      className="form-control form-control-sm text-center border-success"
                      style={{ width: "120px", margin: "0 auto" }}
                    />
                  </td> */}
                  <td>
                    {" "}
                    <input
                      type="text" // changed from "number" to allow commas
                      inputMode="decimal" // better mobile keyboard
                      required
                      value={
                        selectedQuantities[item.id]?.quantity
                          ? formatNumberWithCommas(
                              selectedQuantities[item.id].quantity,
                            )
                          : ""
                      }
                      onChange={(e) => {
                        let input = e.target.value;

                        // Remove all commas
                        let rawValue = input.replace(/,/g, "");

                        // Allow only numbers and one decimal point
                        if (rawValue && !/^\d*\.?\d*$/.test(rawValue)) {
                          return;
                        }

                        // Create synthetic event with raw value (no commas)
                        const syntheticEvent = {
                          ...e,
                          target: {
                            ...e.target,
                            value: rawValue,
                          },
                        };

                        onQuantityChange(syntheticEvent, item);
                      }}
                      className="form-control form-control-sm text-center border-success"
                      style={{ width: "120px", margin: "0 auto" }}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center py-4 text-muted">
                  No items found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {isLoading && (
          <div className="text-center my-3">
            <div className="spinner-border text-success" role="status" />
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryTable;
